/* Handmade by Rosie — optional, paid gift boxes linked to individual cart items. */
(() => {
  'use strict';
  if (window.HbrGiftBox) return;
  const node = document.querySelector('[data-hbr-gift-config]');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  const route = path => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/') + path;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
  const safeURL = value => {
    try { const u = new URL(value, location.origin); return /^https?:$/.test(u.protocol) ? escape(u.href) : ''; }
    catch { return ''; }
  };
  const integer = value => Number.isSafeInteger(Number(value)) && Number(value) > 0 ? Number(value) : 0;
  const isGift = item => item.properties?._hbr_gift_child === '1';
  const parentKey = item => item.parent_relationship?.parent_key;
  const childrenFor = (cart, key) => cart.items.filter(item => isGift(item) && parentKey(item) === key);
  const isParent = item => !parentKey(item) && !isGift(item) && item.properties?._hbr_icon_child !== '1' &&
    item.handle !== config.handle && item.handle !== 'icon-personalisation' && !item.gift_card &&
    item.requires_shipping === true && !item.selling_plan_allocation && !item.has_components && !item.item_components?.length;
  const eligible = new Map(Object.entries(config.eligibility || {}));
  const productRequests = new Map();
  const cards = new Set();
  const callbacks = new WeakMap();
  let cart = null, drawer = null, revision = 0, busy = false, cartBusy = false, sequence = 0;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
    style:'currency', currency:cart?.currency || config.currency
  }).format(Number(cents) / 100);
  const redraw = () => cards.forEach(card => card.render());
  const errorMessage = error => error?.message || 'Your bag could not be updated. Please check it before trying again.';
  async function request(path, payload) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(route(path), {
        method:payload ? 'POST' : 'GET', credentials:'same-origin', cache:'no-store', signal:controller.signal,
        headers:{ Accept:'application/json', ...(payload ? { 'Content-Type':'application/json' } : {}) },
        ...(payload ? { body:JSON.stringify(payload) } : {})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Your bag could not be updated.');
      return data;
    } finally { clearTimeout(timeout); }
  }
  async function readCart() {
    const data = await request('cart.js');
    if (!Array.isArray(data.items) || !Number.isFinite(data.total_price)) throw new Error('Please refresh your bag to check its contents.');
    return data;
  }
  async function productEligible(item) {
    if (!isParent(item)) return false;
    const id = String(item.product_id);
    if (eligible.has(id)) return eligible.get(id);
    if (!productRequests.has(id)) {
      productRequests.set(id, request(`products/${encodeURIComponent(item.handle)}.js`).then(product => {
        const result = String(product.id) === id && Array.isArray(product.tags) && product.tags.includes(config.eligibleTag);
        eligible.set(id, result);
        return result;
      }).finally(() => productRequests.delete(id)));
    }
    return productRequests.get(id);
  }
  async function validateOffer() {
    const product = await request(`products/${encodeURIComponent(config.handle)}.js`);
    const variant = product.variants?.find(v => String(v.id) === String(config.variantId));
    if (product.variants?.length !== 1 || !variant?.available || !integer(variant.price) || !product.featured_image) {
      config.available = false;
      redraw();
      throw new Error('Gift boxes are temporarily unavailable. You can still order your items without one.');
    }
    if (Number(variant.price) !== Number(config.price)) {
      config.price = Number(variant.price);
      redraw();
      throw new Error('The gift-box price has changed. Please review the updated price before adding it.');
    }
  }
  const unavailable = () => busy || cartBusy || !!document.querySelector('.hbr-cart__form[aria-busy="true"]');
  function begin() {
    if (unavailable()) throw new Error('Please wait for your bag to finish updating.');
    busy = true;
    document.documentElement.classList.add('hbr-gift-updating');
    redraw();
    let ended = false;
    return () => { if (!ended) { ended = true; busy = false; document.documentElement.classList.remove('hbr-gift-updating'); redraw(); } };
  }
  function publish(data) {
    cart = data;
    if (window.HbrSharedBag?.render) window.HbrSharedBag.render(data);
    else if (drawer && callbacks.has(drawer)) callbacks.get(drawer)(data);
    else if (window.HbrSharedBag?.refresh) void window.HbrSharedBag.refresh();
  }
  async function update(data, targetDrawer, renderCallback) {
    if (!data || !targetDrawer) return;
    cart = data;
    drawer = targetDrawer;
    if (renderCallback) callbacks.set(targetDrawer, renderCallback);
    const version = ++revision;
    let card = targetDrawer.querySelector('hbr-gift-box[data-mode="cart"]');
    if (!card) {
      const footer = targetDrawer.querySelector('.hbr-cart-drawer__footer');
      if (!footer) return;
      card = document.createElement('hbr-gift-box');
      card.dataset.mode = 'cart';
      footer.prepend(card);
    }
    // Existing boxes remain visible/removable even if their product sells out.
    card.parents = data.items.filter(item => (isParent(item) && eligible.get(String(item.product_id))) || childrenFor(data, item.key).length);
    card.render();
    const checks = await Promise.allSettled(data.items.map(productEligible));
    if (version !== revision || !card.isConnected) return;
    card.parents = data.items.filter((item, i) => checks[i].status === 'fulfilled' && checks[i].value || childrenFor(data, item.key).length);
    card.render();
  }
  // Preserve uploaded personalisation files and icon child lines in the same request.
  function addToForm(form, quantity, title, group) {
    const nested = form.has('items[0][id]');
    const id = String(form.get(nested ? 'items[0][id]' : 'id') || '');
    if (!/^\d+$/.test(id) || id === String(config.variantId)) throw new Error('Please select the product options again.');
    if (form.get('selling_plan') || form.get('items[0][selling_plan]')) throw new Error('Gift boxes are available for one-time purchases only.');
    const result = new FormData();
    for (const [key, value] of form.entries()) {
      if (nested || key === 'sections' || key === 'sections_url') result.append(key, value);
      else if (key === 'id' || key === 'quantity') result.append(`items[0][${key}]`, value);
      else if (/^properties\[.+\]$/.test(key)) result.append(`items[0][properties][${key.slice(11,-1)}]`, value);
    }
    result.set('items[0][quantity]', String(quantity));
    result.set('items[0][properties][_hbr_gift_group]', group);
    let index = 1;
    for (const key of result.keys()) {
      const match = /^items\[(\d+)\]/.exec(key);
      if (match) index = Math.max(index, Number(match[1]) + 1);
    }
    const prefix = `items[${index}]`;
    result.set(`${prefix}[id]`, String(config.variantId));
    result.set(`${prefix}[parent_id]`, id);
    result.set(`${prefix}[quantity]`, String(quantity));
    result.set(`${prefix}[properties][For]`, title);
    result.set(`${prefix}[properties][_hbr_gift_child]`, '1');
    result.set(`${prefix}[properties][_hbr_gift_group]`, group);
    return result;
  }
  async function prepareForm(form, productForm) {
    const card = productForm?.querySelector('hbr-gift-box[data-mode="product"]');
    if (card) card.pending = null;
    if (!card?.selected) return form;
    if (!config.available) throw new Error('Gift boxes are unavailable. Remove the gift-box selection to continue.');
    await validateOffer();
    const quantity = integer(form.get('items[0][quantity]') || form.get('quantity') || 1);
    if (!quantity) throw new Error('Please enter a valid quantity.');
    const group = crypto.randomUUID();
    const result = addToForm(form, quantity, card.dataset.productTitle, group);
    card.pending = { group, quantity };
    return result;
  }
  function verifyCart(data, productForm) {
    const card = productForm?.querySelector('hbr-gift-box[data-mode="product"]');
    if (!card?.pending) return;
    const { group, quantity } = card.pending;
    const parent = data.items.find(item => !isGift(item) && item.properties?._hbr_gift_group === group);
    const boxes = data.items.filter(item => isGift(item) && item.properties?._hbr_gift_group === group);
    if (!parent || parent.quantity !== quantity || boxes.length !== 1 || String(boxes[0].variant_id || boxes[0].id) !== String(config.variantId) || boxes[0].quantity !== quantity || parentKey(boxes[0]) !== parent.key) {
      throw new Error('The gift box could not be confirmed. Please check your bag before trying again.');
    }
    card.pending = null;
  }
  async function changeBox(card, key, remove) {
    if (unavailable()) return;
    const quoted = card.parents.find(item => item.key === key);
    if (!quoted) return;
    const end = begin();
    let data;
    card.message = '';
    try {
      data = await readCart();
      const parent = data.items.find(item => item.key === key);
      if (!parent || parent.quantity !== quoted.quantity) throw new Error('Your bag has changed. Please review the items and try again.');
      const boxes = childrenFor(data, key);
      if (remove) {
        // Resolve a fresh child key on each pass; discounts can change line keys.
        for (const original of boxes) {
          const current = data.items.find(item => isGift(item) && item.properties?._hbr_gift_group === original.properties?._hbr_gift_group);
          if (current) data = await request('cart/change.js', { id:current.key, quantity:0 });
        }
        card.message = 'Gift box removed.';
      } else if (boxes.length) {
        card.message = 'A gift box is already added for this item.';
      } else {
        if (!config.available || !await productEligible(parent)) throw new Error('A gift box is not available for this item.');
        await validateOffer();
        const group = crypto.randomUUID();
        await request('cart/add.js', { items:[{
          id:Number(config.variantId), quantity:parent.quantity, parent_line_key:parent.key,
          properties:{ For:parent.product_title, _hbr_gift_child:'1', _hbr_gift_group:group }
        }] });
        data = await readCart();
        const added = data.items.find(item => isGift(item) && item.properties?._hbr_gift_group === group);
        const confirmedParent = data.items.find(item => item.key === parentKey(added || {}));
        if (!added || String(added.variant_id || added.id) !== String(config.variantId) || added.quantity !== parent.quantity || !confirmedParent || String(confirmedParent.variant_id) !== String(parent.variant_id) || JSON.stringify(confirmedParent.properties || {}) !== JSON.stringify(parent.properties || {})) {
          throw new Error('Please check your bag: the requested gift-box quantity could not be confirmed.');
        }
        card.message = parent.quantity === 1 ? 'Gift box added.' : `${parent.quantity} gift boxes added.`;
      }
    } catch (error) {
      card.message = errorMessage(error);
      // Never retry an uncertain add automatically; it may already have succeeded.
      try { data = await readCart(); } catch { card.message += ' Refresh your bag before continuing.'; }
    } finally {
      if (data) publish(data);
      end();
      card.render();
    }
  }
  class GiftBox extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.instanceId ||= `hbr-gift-details-${++sequence}`;
      this.expanded ||= false;
      this.selected ||= false;
      this.parents ||= [];
      cards.add(this);
      if (this.dataset.mode === 'product') eligible.set(String(this.dataset.productId), true);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-gift-action]');
        if (!button || button.disabled) return;
        const action = button.dataset.giftAction;
        if (action === 'view') {
          this.expanded = !this.expanded;
          this.render();
          this.querySelector('[data-gift-action="view"]')?.focus({ preventScroll:true });
        } else if (this.dataset.mode === 'product') {
          if (unavailable()) return;
          this.selected = action === 'select';
          this.expanded = false;
          this.message = this.selected ? 'Selected — added with this item when you add it to your bag.' : 'Gift box removed from your selection.';
          this.render();
          this.querySelector('[data-gift-action="view"]')?.focus({ preventScroll:true });
          this.dispatchEvent(new CustomEvent('hbr:gift-change', { bubbles:true }));
        } else {
          void changeBox(this, button.dataset.parentKey, action === 'remove');
        }
      }, { signal:this.controller.signal });
      document.getElementById(this.dataset.formId)?.addEventListener('reset', () => {
        this.selected = false; this.expanded = false; this.pending = null; this.message = ''; this.render();
        this.dispatchEvent(new CustomEvent('hbr:gift-change', { bubbles:true }));
      }, { signal:this.controller.signal });
      this.render();
    }
    disconnectedCallback() { cards.delete(this); this.controller?.abort(); this.controller = null; }
    render() {
      if (!this.isConnected) return;
      const product = this.dataset.mode === 'product';
      const hasBoxes = !product && this.parents.some(parent => childrenFor(cart, parent.key).length);
      this.hidden = product ? !config.available && !this.selected : !this.parents.length || (!config.available && !hasBoxes);
      if (this.hidden) return;
      const active = this.contains(document.activeElement) ? document.activeElement : null;
      const focus = active?.dataset.giftAction;
      const focusKey = active?.dataset.parentKey;
      const locked = unavailable();
      const selected = product ? this.selected : hasBoxes;
      const heading = selected ? (product ? '✓ Gift box selected' : '✓ Gift box added') : 'Make it gift-ready';
      const thumbnail = safeURL(config.thumbnail || config.image);
      const photo = safeURL(config.image);
      const rows = product ? `
        <button type="button" class="hbr-gift__action" data-gift-action="${this.selected ? 'unselect' : 'select'}" ${locked || (!config.available && !this.selected) ? 'disabled' : ''}>${this.selected ? 'Remove gift box' : `Add gift box — ${escape(money(config.price))}`}</button>` : this.parents.map(parent => {
        const boxes = childrenFor(cart, parent.key);
        const count = boxes.reduce((n, box) => n + box.quantity, 0);
        const name = parent.properties?.Name || parent.properties?.['Name or text'];
        const variant = parent.variant_title && parent.variant_title !== 'Default Title' ? parent.variant_title : '';
        const detail = [variant, name ? `Name: ${name}` : '', `${parent.quantity} ${parent.quantity === 1 ? 'item · 1 box' : 'items · 1 box each'}`].filter(Boolean).join(' · ');
        return `<div class="hbr-gift__item"><div><span class="hbr-gift__item-name">${escape(parent.product_title)}</span><span class="hbr-gift__item-detail">${escape(detail)}</span></div><div>${count ?
          `<span class="hbr-gift__added">✓ ${count === 1 ? 'Added' : `${count} added`}</span><button type="button" class="hbr-gift__remove" data-gift-action="remove" data-parent-key="${escape(parent.key)}" aria-label="Remove gift box for ${escape(parent.product_title)}" ${locked ? 'disabled' : ''}>Remove</button>` :
          `<button type="button" class="hbr-gift__action" data-gift-action="add" data-parent-key="${escape(parent.key)}" aria-label="Add ${parent.quantity} gift ${parent.quantity === 1 ? 'box' : 'boxes'} for ${escape(parent.product_title)} — ${escape(money(parent.quantity * config.price))}" ${locked || !config.available ? 'disabled' : ''}>Add · ${escape(money(parent.quantity * config.price))}</button>`}</div></div>`;
      }).join('');
      this.innerHTML = `<button type="button" class="hbr-gift__summary" data-gift-action="view" aria-expanded="${this.expanded}" aria-controls="${this.instanceId}">
        ${thumbnail ? `<img class="hbr-gift__thumb" src="${thumbnail}" width="56" height="56" alt="Gift box" loading="lazy">` : '<span></span>'}
        <span><span class="hbr-gift__heading">${heading}</span><span class="hbr-gift__price">${config.available ? `Gift box · ${escape(money(config.price))} each` : 'Gift boxes currently unavailable'}</span></span>
        <span class="hbr-gift__view">${this.expanded ? 'Close' : selected ? 'View' : 'View & add'}</span></button>
        <div class="hbr-gift__details" id="${this.instanceId}" ${this.expanded ? '' : 'hidden'}>
          ${photo ? `<img class="hbr-gift__photo" src="${photo}" width="600" height="400" alt="${escape(config.title)}" loading="lazy">` : ''}
          <p class="hbr-gift__description">${escape(config.description)}</p><div class="hbr-gift__items">${rows}</div>
        </div><p class="hbr-gift__status" role="status" aria-live="polite">${escape(this.message || '')}</p>`;
      if (focus) {
        const replacement = [...this.querySelectorAll('[data-gift-action]')].find(button => button.dataset.giftAction === focus && button.dataset.parentKey === focusKey);
        (replacement && !replacement.disabled ? replacement : this.querySelector('[data-gift-action="view"]'))?.focus({ preventScroll:true });
      }
    }
  }
  window.HbrGiftBox = {
    update:(data, target, callback) => { void update(data, target, callback).catch(() => {}); },
    setCartBusy:value => { cartBusy = !!value; redraw(); },
    begin, prepareForm, verifyCart,
    productTotal:(base, root) => {
      const choice = root?.querySelector('hbr-gift-box[data-mode="product"]');
      if (!choice?.selected) return null;
      const icons = root.querySelector('hbr-icon-picker');
      const iconPrice = icons?.active ? icons.count * Number(icons.config?.price || 0) : 0;
      return money(Number(base) + Number(config.price) + iconPrice);
    },
    get busy() { return busy; }
  };
  // Window capture runs before the existing drawer's document capture listener.
  // While a paid mutation is pending, prevent duplicate adds and early checkout.
  window.addEventListener('click', event => {
    if (!busy || !(event.target instanceof Element)) return;
    if (event.target.closest('[data-hbr-cart-remove], .hbr-cart-drawer__checkout, .hbr-cart-drawer__view-bag, .hbr-cart__checkout, .hbr-cart__remove, .hbr-pdp__add')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  window.addEventListener('submit', event => {
    if (busy && event.target.matches('[id^="HbrProductForm-"], [id^="HbrCartForm-"]')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  customElements.define('hbr-gift-box', GiftBox);
  // If the customer opened the bag before this deferred asset arrived, catch up.
  if (document.querySelector('[data-hbr-cart-drawer].is-open')) void window.HbrSharedBag?.refresh();
})();
